import request from '@/utils/request'
export function getAgentList(params){
  return request({
    url: `/agent/${params}`,
    method:'GET'
  })
}

export function getAgentById(id){
  return request({
    url: `/agent/${id}/`,
    method:'GET',
  })
}

//update
export function updateAgent(id, data){
  return request({
    url: `/agent/${id}/`,
    method:'PATCH',
    data
  })
}

// 归属维护人
export function getMaintainerList(){
  return request({
    url: `/system/maintainers/`,
    method:'GET',
  })
}

// 价格设置列表
export function checkAgentPrice(data){
  return request({
    url: `/system/check_agent_price/`,
    method:'POST',
    data
  })
}

// 设置价格
export function setAgentPrice(data){
  return request({
    url: `/system/set_agent_price/`,
    method:'POST',
    data
  })
}

export function setAgentAFPrice(data){
  return request({
    url: `/system/set_afconf/`,
    method:'POST',
    data
  })
}

// 账户充值

export function setRecharge(data){
  return request({
    url: `/system/recharge/`,
    method:'POST',
    data
  })
}

export function antiRecharge(data){
  return request({
    url: `/system/anti_recharge/`,
    method:'POST',
    data
  })
}

// 重置密码

export function resetPassword(data){
  return request({
    url: `/system/reset_password/`,
    method:'POST',
    data
  })
}


// finance_list
export function adminFinanceList(params){
  return request({
    url: `/agent/finance_list/${params}`,
    method:'GET',
  })
}



// WEBPACK FOOTER //
// ./src/api/agent.js